import { environment as base } from './environment';
import { apiUrls } from './api-urls';
import type { Environment } from './environment';

export const environment: Environment = {
  ...base,
  apiProxyUrl: 'https://api-stg.uhg.com/api/pdr/msr/uhci-aws-core-api-dev/v1.0.0/',
  ohidApiProxyUrl: 'https://uhci-ui-external-dev.optum.com/',
  postLoginProxyUrl: '/uhci/login/dev/',
  ssoApiProxyUrl: 'https://uhci-ui-internal-dev.optum.com/',
  originUrl: '/',
  redirectUri: 'https://uhci-ui-internal-dev.optum.com/',
  domain: 'localhost',
  domainEnvironment: ['https://uhcinsights-internal-dev.uhc.com/'],
  cookieEnvironment: 'DEV_',
  featureFlagUrl: '/feature-flags/',
  upstreamEnv: 'dev',
  goldCardEnvironment: 'dev',
  goldCardabyssparcelUrl: 'https://uhci-ui-internal-dev.optum.com/abyss-parcel.js',
  qualtricksEnvCheck: 'dev',
  clickStreamUrl:
    'https://assets.adobedtm.com/512027f42d3c/c18a9fa8e51b/launch-ENacdc6d1acf734bcd95703e446bd1de1d-development.min.js',
  production: false,
  staging: true,
  qualtrics: true,
  apiUrls: {
    ...apiUrls,
    bulkTinRUrl: '/bulk-api/',
    SsoRedirectUri:
      'https://stage-sso.uhc.com/ext/as/authorization.oauth2?pfidpadapterid=OptumIdOIDCStage&client_id=PED42235&response_' +
      'type=code&redirect_uri=https://uhci-ui-external-dev.optum.com/login&scope=openid+profile+email&state=PED&prompt=none',
    SsoRedirectLogin:
      'https://identity.nonprod.onehealthcareid.com/oidc/authorize?client_id=PED42235&response_type=code' +
      '&redirect_uri=https://uhci-ui-external-dev.optum.com/login&scope=openid+profile+email&state=PED&prompt=login',
    SsoLogoutUrl:
      'https://api-stage.linkhealth.com/session/signout?redirect=https://provider-stage.linkhealth.com/' +
      'content/odin/en/provider-dashboard/public/signout.html?logOut=true',
    linkLoginPage: 'https://provider-stage.linkhealth.com',
    providerLoginPage: 'https://secure-nonprod.uhcprovider.com/stage/#/',
  },
};
